import Auth from "./Auth/services";

export default {
  Auth,
};



// WEBPACK FOOTER //
// ./src/modules/Services.js